<template>
	<div class="popup d-flex flex-column h-100" tabscope>
		<div v-if="settings.header === true && (title || buttons)" class="pp-header">
			<div v-if="title" class="pp-title">
				{{ title }}
			</div>
			<div v-if="title && buttons" class="pp-header-separator"></div>
			<div v-if="buttons" class="pp-toolbar" tabscope tabindex="2">
				<nk-button v-for="(b, i) in buttons" :key="i" :tabindex="i + 1" class="btn btn-sm" :class="{ 'btn-primary': b.isPrimary, 'btn-outline-primary': !b.isPrimary }" :options="b" @click="buttonClicked"></nk-button>
			</div>
		</div>
		<div v-if="settings.component" class="pp-body-content">
			<component :is="settings.component" :data="settings.data" :options="settings.options" @buttons-changed="buttonsChanged" @title-changed="t => title = t" @close-button-clicked="closeButtonClicked" @resolve="resolved" @reject="rejected" ref="component" :tabindex="1">
			</component>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'

	export default {
		props: {
			options: {}
		},
		emits: ['close-button-clicked', 'resolve', 'reject'],
		data() {
			return {
				buttons: null,
				title: null
			}
		},
		computed: {
			settings() {
				let opt = _.extend({
					header: true
				}, this.options)
				opt.component = this.makeRawComponent(opt.component)
				return opt
			}
		},
		created() {

		},
		mounted() {
			this.$refs.component.$el.focus()
		},
		methods: {
			buttonClicked(button, e) {
				e.preventDefault()
				var handle = button.handle
				if (handle != null && _.isFunction(handle)) {
					handle(button, this.settings, e)
				}
			},
			buttonsChanged(buts) {
				if (_.isArguments(buts)) {
					buts = Array.from(buts)
				}

				if (buts == null || !Array.isArray(buts) || buts.length === 0) {
					return
				}

				this.buttons = buts.map(_.clone)
			},

			closeButtonClicked() {
				this.$emit('close-button-clicked')
			},

			resolved(response) {
				this.$emit('resolve', response)
			},
			rejected(error) {
				this.$emit('reject', error)
			},

			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'popup-button-click',
					el: this.$el,
					ctrlKey: undefined,
					altKey: undefined,
					shiftKey: undefined,
					context: this,
					handler: function (sender, e) {
						if (!Array.isArray(this.buttons) || this.buttons.length === 0)
							return

						var _buttons = this.buttons.map(b => _.extend({ shortcut: {} }, b))
						_buttons = _buttons.filter(b => b.shortcut.keyCode === e.keyCode &&
							(b.shortcut.ctrlKey == null || b.shortcut.ctrlKey === e.ctrlKey) &&
							(b.shortcut.shiftKey == null || b.shortcut.shiftKey === e.shiftKey) &&
							(b.shortcut.altKey == null || b.shortcut.altKey === e.altKey))

						if (_buttons.length > 0) {
							let b = _buttons[0]

							e.preventDefault()
							this.buttonClicked(b, e)
							return true
						}
					}
				})
			}
		},
	}
</script>
<style></style>
